<p-card>
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Acción en custom
        </div>
    </ng-template>
    <div class="p-grid">
        <div class="p-field p-mb-0 p-pb-0 p-md-12">
            <label for="task_action_id">Tipo</label>
            <p-dropdown name="task_action_id" [(ngModel)]="action.task_action_id" [showClear]="true"
                [options]="tasksActionTypes" optionLabel="name" optionValue="id" placeholder="-"
                appendTo="body"></p-dropdown>
        </div>
        <div class="p-field p-mb-0 p-pb-0 p-md-12">
            <label for="task_action_description">Descripción</label>
            <textarea name="task_action_description" [(ngModel)]="action.task_action_description" rows="2"
                style="width: 100%;resize: vertical;"></textarea>
        </div>
        <div class="p-field p-mb-0 p-pb-0 p-md-12">
            <label for="responsible">Responsable</label>
            <p-dropdown name="responsible" [(ngModel)]="task.responsible_user_id" [showClear]="true"
            [options]="responsibles" optionLabel="name" optionValue="id" placeholder="-"></p-dropdown>
        </div>
        <div class="p-field p-mb-0 p-pb-0 p-md-6">
            <label for="task_action_scheduled_date">Fecha</label>
            <p-calendar name="task_action_scheduled_date" [(ngModel)]="action.task_action_scheduled_date"
                showTime="true" hourFormat="24" dateFormat="dd/mm/yy" appendTo="body" [stepMinute]="15"></p-calendar>
        </div>
        <div class="p-field p-mb-0 p-pb-0 p-md-6">
            <label>&nbsp;</label>
            <p-splitButton label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (onClick)="save($event)"
                [model]="items" appendTo="body"></p-splitButton>
        </div>
    </div>
</p-card>